import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Maintenance } from '../../core/models/maintenance.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-maintenance-detail',
  templateUrl: './maintenance-detail.component.html',
  styleUrls: ['./maintenance-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class MaintenanceDetailComponent implements OnInit {
  @Input() maintenance: Maintenance | null = null; // Recibir la mantención
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
